<template>
    <div id="layout" class="docker__item">
      <van-cell is-link @click="showPopup">
        <van-icon name="newspaper-o" size=".6rem"/>
        <span class="docker__item__text">版面</span>
      </van-cell>
      <van-popup
        class="docker__item"
        v-model:show="show"
        position="left"
        :style="{height:'85%',width: '70% ', padding:'0.1rem 0'}"
        >
          <div
          v-for="(item, index) in layoutList"
          :key="index"
          class="docker__page"
          @click="addPageListData({
            'index': index,
            'id': item.id,
            'pageNum': item.pageNum,
            'pageName': item.pageName,
            'accessName': item.accessName,
            'pagePicFile': item.pagePicFile,
            'newsArea': item.newsArea,
            'outfilePath': item.outfilePath
          })"
          >
          <router-link
          :to="`/${item.accessName}`"
          >
          <div class="docker__page__wrapper">
            <span class="docker__page__wrapper__span">
              {{item.pageNum}}
            </span>
            {{item.pageName}}
          </div>
          </router-link>
          </div>
      </van-popup>
    </div>
</template>
<script>
import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { get } from '../../utils/request'
export default {
  name: 'Layout',
  props: {
    pageDate: String
  },
  setup (props, { emit }) {
    // 应该用reactive，但是没数据，用ref就有数据
    const layoutList = ref([])
    const defaultList = ref([])
    const emitPageList = ref({})
    const layoutDate = ref('')
    const store = useStore()
    const newspaper = computed(() => store.state.newspaper)
    const pageDate = computed(() => store.state.pageDate)
    const getLayoutList = async () => {
      if (pageDate.value !== '') {
        layoutDate.value = pageDate.value
      } else {
        layoutDate.value = props.pageDate
      }
      // const url = `tablePageController/getTablePageList?pageDate=2021-12-29&accessName=${accessName}`
      const url = `tablePageController/getTablePageList?pageDate=${layoutDate.value}&accessName=${newspaper.value}`
      const result = await get(url)
      if (result.code === 200 && result.list.length) {
        layoutList.value = result.list
        store.dispatch('addAllPageListData', layoutList.value)
        defaultList.value = {
          index: 0,
          id: layoutList.value[0].id,
          pageNum: layoutList.value[0].pageNum,
          pageName: layoutList.value[0].pageName,
          pageDate: layoutList.value[0].pageDate,
          accessName: layoutList.value[0].accessName,
          pagePicFile: layoutList.value[0].pagePicFile,
          newsArea: layoutList.value[0].newsArea,
          outfilePath: layoutList.value[0].outfilePath
        }
        console.log(layoutList.value)
        store.dispatch('getDefaultList', defaultList.value)
      } else {
        alert('当前日期没有数据哦')
      }
    }
    const addPageListData = (list) => {
      emit('emit-daily', list)
      emitPageList.value = list
      store.dispatch('addPageListData', emitPageList)
      show.value = false
    }
    const pageList = computed(() => store.state.pageList)

    watch(() => {
      getLayoutList()
    })
    const show = ref(false)

    const showPopup = () => {
      show.value = true
    }
    return {
      show,
      showPopup,
      layoutList,
      emitPageList,
      pageList,
      addPageListData
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker__item {
    flex: 1;
    text-align: center;
    color: $content-fontcolor;
    &__text{
      font-size: .45rem;
      margin-left: .05rem;
      display: inline-block;

    }
    .docker__page{
      width: 100%;
      display: block;
      text-align: left;
      padding: 0 0.5rem;
      font-size: .4rem;
      line-height: 1rem;
      box-sizing: border-box;
      border-bottom:1px solid #ddd;
      &__wrapper{
        color: #666666;
      }
        &__span{
          margin-right: 10px;
          color: #666666;
        }
    }
  }
</style>
